import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import AngleBracketRightIcon from "../../icons/AngleBracketRightIcon";
import Btn from "../Btn";
import Page from "./PageSimple";

function PaginationSimple({
  className,
  currentPage,
  totalResults,
  pageSize,
  onPageChange,
}) {
  const totalPages = Math.floor(totalResults / pageSize);
  const maxPage = totalPages + (totalResults % pageSize ? 1 : 0);
  const hasNext = currentPage < maxPage;
  const hasPrev = currentPage > 1;

  const onNext = useCallback(() => {
    if (hasNext) {
      onPageChange(currentPage + 1);
    }
  }, [hasNext, currentPage]);

  const onPrevious = useCallback(() => {
    if (hasPrev) {
      onPageChange(currentPage - 1);
    }
  }, [hasPrev, currentPage]);

  const onSelect = useCallback((page) => {
    onPageChange(page);
  }, []);

  const pages = useMemo(
    () =>
      [currentPage - 1, currentPage, currentPage + 1]
        .filter((x) => x < maxPage)
        .filter((x) => x > 1),
    [currentPage, maxPage]
  );

  return (
    <div className={className}>
      <div className="tw-mr-3" data-testid="show-pagination-text">
        <div className="tw-flex tw-items-center">
          <Btn onSubmit={() => onPrevious()}>
            <AngleBracketRightIcon
              size={10}
              className="tw-fill-current tw-transform tw-rotate-180"
            />
          </Btn>

          <Page num={1} onSelect={onSelect} currentPage={currentPage} />

          {currentPage > 3 ? <div>...</div> : null}

          {pages.map((x) => (
            <Page
              num={x}
              onSelect={onSelect}
              key={x}
              currentPage={currentPage}
            />
          ))}

          {currentPage < maxPage - 2 ? <div>...</div> : null}

          {maxPage > 1 && (
            <Page num={maxPage} onSelect={onSelect} currentPage={currentPage} />
          )}

          <Btn onSubmit={() => onNext()}>
            <AngleBracketRightIcon size={10} className="tw-fill-current" />
          </Btn>
        </div>
      </div>
    </div>
  );
}

PaginationSimple.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};

PaginationSimple.defaultProps = {
  className: "tw-w-full tw-flex tw-noselect",
  pageSize: 10,
};

export default PaginationSimple;
